/**
 * Shared pdf.js Document options — self-hosted auxiliary assets.
 *
 * The files live in public/static/pdfjs/ (copied from the pdfjs-dist build
 * that react-pdf bundles; re-copy when react-pdf upgrades). They are
 * REQUIRED for correct rendering, not nice-to-haves:
 *   - wasmUrl: JPEG2000 + ICC decoding moved to WASM in pdf.js 5.x. Scanned
 *     government PDFs (FOIA releases) are JPX-heavy — without this their
 *     pages paint as blank white canvases with only the text layer visible.
 *   - standardFontDataUrl: non-embedded standard-14 fonts.
 *   - cMapUrl: CID/CJK character maps.
 * Self-hosting (instead of unpkg) keeps airgapped deployments working.
 *
 * Module-level constant on purpose: react-pdf re-loads the document whenever
 * the options object identity changes.
 */
export const PDFJS_DOCUMENT_OPTIONS = {
  cMapUrl: '/static/pdfjs/cmaps/',
  cMapPacked: true,
  standardFontDataUrl: '/static/pdfjs/standard_fonts/',
  wasmUrl: '/static/pdfjs/wasm/',
  iccUrl: '/static/pdfjs/iccs/',
};
